import React from 'react'

export type CommunitySplitPillVariant = 'teal' | 'gray' | 'pink'

interface CommunitySplitPillTagProps {
  leftLabel: React.ReactNode
  leftIconSvg?: React.ReactNode
  leftTrailingIconSvg?: React.ReactNode
  rightIconSvg?: React.ReactNode
  rightLabel?: string | number
  variant?: CommunitySplitPillVariant
  onClick?: () => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  disabled?: boolean
  ariaLabel?: string
  ariaHasPopup?: 'listbox' | 'menu' | 'dialog' | 'true'
  ariaExpanded?: boolean
  className?: string
  rightOnly?: boolean
}

function CommunitySplitPillTag ({
  leftLabel,
  leftIconSvg,
  leftTrailingIconSvg,
  rightIconSvg,
  rightLabel,
  variant = 'teal',
  onClick,
  onMouseEnter,
  onMouseLeave,
  disabled = false,
  ariaLabel,
  ariaHasPopup,
  ariaExpanded,
  className = '',
  rightOnly = false,
}: CommunitySplitPillTagProps) {
  const hasRight = rightIconSvg || rightLabel !== undefined
  const baseClass = 'split-pill-tag'
  const rootClasses = [
    baseClass,
    `${baseClass}--${variant}`,
    hasRight ? '' : `${baseClass}--single`,
    className,
  ].filter(Boolean).join(' ')

  const leftContent = (
    <span className={`${baseClass}__left ${baseClass}__left--${variant}`}>
      {leftIconSvg}
      {leftLabel}
      {leftTrailingIconSvg}
    </span>
  )

  const rightContent = hasRight ? (
    <span className={`${baseClass}__right ${baseClass}__right--${variant}`}>
      {rightIconSvg}
      {rightLabel !== undefined ? rightLabel : null}
    </span>
  ) : null

  if (rightOnly) {
    return (
      <div
        className={rootClasses}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <button
          type="button"
          className={`${baseClass}__left ${baseClass}__left--${variant}`}
          onClick={onClick}
          disabled={disabled}
          aria-label={ariaLabel}
          aria-haspopup={ariaHasPopup}
          aria-expanded={ariaExpanded}
        >
          {leftIconSvg}
          {leftLabel}
          {leftTrailingIconSvg}
        </button>
        {rightContent}
      </div>
    )
  }

  return (
    <button
      type="button"
      className={rootClasses}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      disabled={disabled}
      aria-label={ariaLabel}
      aria-haspopup={ariaHasPopup}
      aria-expanded={ariaExpanded}
    >
      {leftContent}
      {rightContent}
    </button>
  )
}

export default CommunitySplitPillTag
